<template>
  <div class="content-page card-coupon-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button v-if="shopIsMaster" type="success" size="small" @click="addCouponDialogVisible = true">添加优惠券</el-button>
        </div>
        <div class="header-right">
          <div class="activity-name pr30">优惠券名称</div>
          <el-input clearable placeholder="请输入优惠券名称" v-model="keywords" class="pr30" type="primary" size="small"></el-input>
          <el-select type="primary" size="small" v-model="cardStatus" placeholder="请选择" class="pr30">
            <el-option v-for="item in cardStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="couponValues" clearable type="primary" size="small" placeholder="请选择" class="pr30">
            <el-option v-for="item in couponScreenList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-button type="primary" size="small" @click="search">搜索</el-button>
        </div>
        <!-- addCouponDialogVisible = true -->
        <!-- <el-button type="danger" @click="addAllianceCouponDialogVisible = true">添加联盟优惠券</el-button> -->
      </div>
      <div class="tab-content">
        <div class="flex-row-start">
          <div class="pr30">营销统计</div>
          <div class="pr30 bold">
            已使用：
            <span class="colorblue">{{ usedCount }}</span> 张
          </div>
          <div class="pr30 bold">
            合计：
            <span class="color-orange">{{ deductionAmount }}</span> 元
          </div>
          <div class="colorblue" @click="lookMore" v-if="usedCount != 0 && deductionAmount != 0">
            查看更多
          </div>
          <el-button v-if="shopIsMaster" type="success" size="small" @click="goAllianceCoupon">商家联盟券列表</el-button>
        </div>
        <div class="list">
          <el-table :data="tableData" style="width: 100%" :max-height="550" v-loading="isTableLoading" element-loading-background="rgba(0, 0, 0, 0.3)" element-loading-text="数据正在加载中" element-loading-spinner="el-icon-loading">
            <el-table-column align="center" prop="title" label="优惠券名称"></el-table-column>
            <el-table-column align="center" prop="price" label="优惠券金额">
              <template slot-scope="scope">满{{ scope.row.minUsePrice }}减{{ scope.row.price }}</template>
            </el-table-column>
            <el-table-column align="center" prop="overCount" label="剩余/总数">
              <template slot-scope="scope">{{ scope.row.overCount }}/{{ scope.row.totalCount }}</template>
            </el-table-column>
            <el-table-column align="center" prop="expireDay" label="有效期" width="220px" />
            <el-table-column align="center" prop="orderType" label="优惠券类型">
              <template slot-scope="scope">
                {{
                  orderType[scope.row.orderType]
                    ? orderType[scope.row.orderType].title
                    : "未知"
                }}
              </template>
            </el-table-column>
            <el-table-column align="center" prop="orderStatus" label="审核状态">
              <template slot-scope="scope">
                <div>
                  {{
                    +new Date() - +new Date(scope.row.expireDay) > 86400000
                      ? "过期"
                      : orderStatusOptions[scope.row.orderStatus]
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="orderMark" label="审核内容"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="offCashCouponUsedDetail(scope.row)" v-if="scope.row.orderStatus == 2 && shopIsMaster">停用</el-button>
                <el-button type="text" @click="lookSingleDetail(scope.row)">查看</el-button>
                <el-button type="text" v-if="scope.row.sendCouponQrCodeValue" @click="downLoadCode(scope.row)">下载二维码</el-button>
                <el-button type="text" v-if="scope.row.orderType == 3" @click="createAppltQrcode(scope.row)">二维码</el-button>
                <el-button type="text" @click="resetSubmit(scope.row)" v-if="
                  (scope.row.orderType == 11 || scope.row.orderType == 21) &&
                  scope.row.orderStatus == 101 &&
                  shopIsMaster
                ">重新提交</el-button>
                <el-button v-if="shopIsMaster" type="text" @click="deleteCashCoupon(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <div v-if="tableData.length > 0" class="block" style="float: right; margin-top: 10px">
            <el-pagination @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
          </div>
        </div>
        <div class="none">
          <qrcode :value="sendCouponQrCodeValue" :options="{ size: 300 }" class="code-canvas"></qrcode>
        </div>
      </div>
    </div>
    <!-- 添加优惠券 -->
    <el-dialog title="添加优惠券" :visible.sync="addCouponDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
      <span>
        <el-form :model="addCouponForm" :rules="addCouponRules" ref="addCouponForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="券类型">
            <el-select popper-class="coupon-list" v-model="addCouponForm.chooseCouponId" placeholder="请选择">
              <el-option-group v-for="group in couponList" :key="group.typeName" :label="group.typeName">
                <el-option v-for="item in group.comprehensiveStampsList" :key="item.id" :label="item.title" :value="item.id">
                  <div class="comprehensiveStamps">
                    <div class="img">
                      <img :src="item.imgUrl" />
                    </div>
                    <div class="couponExplain">
                      <div class="title">{{ item.title }}</div>
                      <div class="title1">
                        {{ item.subTitle }}
                      </div>
                      <!-- <div v-show="item.subTitle.length > 32" class="triangle-up"></div> -->
                    </div>
                  </div>
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item :label="!isHavPriceLimit ? '券名称' : '活动名称'" prop="title">
            <el-input v-model="addCouponForm.title"></el-input>
          </el-form-item>
          <el-form-item :label="!isHavPriceLimit ? '券金额' : '消费满'" prop="price">
            <el-input-number v-model="addCouponForm.minUsePrice" :precision="2" :step="1" :min="0" v-if="isHavPriceLimit"></el-input-number>
            <span v-if="isHavPriceLimit" style="padding: 0 8px; box-sizing: border-box">减</span>
            <el-input-number v-model="addCouponForm.price" :precision="2" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="券数量" prop="totalCount">
            <el-input v-model="addCouponForm.totalCount" placeholder="请输入优惠券数量" onchange="this.value=this.value.replace(/[^\d]/g,'')"></el-input>
          </el-form-item>
          <el-form-item label="有效时间" prop="expireDay">
            <el-date-picker v-model="addCouponForm.expireDay" type="datetime" placeholder="请选择有效时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="使用须知" prop="introduce">
            <el-input type="textarea" placeholder="请输入使用须知" v-model="addCouponForm.introduce"></el-input>
          </el-form-item>
          <el-form-item label="备注" v-if="isShowRemark">
            <el-input type="textarea" placeholder="请输入备注" v-model="addCouponForm.applyMark"></el-input>
          </el-form-item>
          <el-form-item :label="'开启折上优惠'" prop="openDoubleDiscounts" v-if="isShowDoubleDiscountsSetting">
            <el-switch v-model="addCouponForm.openDoubleDiscounts"></el-switch>
            <span class="pl10">在使用会员折扣的同时可使用优惠券</span>
          </el-form-item>
          <el-form-item :label="'弹窗提示'" prop="enablePopup" v-if="addCouponForm.chooseCouponId === 0">
            <el-switch v-model="addCouponForm.enablePopup"></el-switch>
            <span class="pl10">打开小程序首页弹窗提示领取</span>
          </el-form-item>
          <el-form-item :label="'小程序显示'" prop="isShow" v-if="isShowAppltSetting">
            <el-switch v-model="addCouponForm.isShow"></el-switch>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCouponDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPublishCashCoupon">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加联盟优惠券 -->
    <el-dialog title="添加联盟优惠券" :visible.sync="addAllianceCouponDialogVisible" width="30%">
      <span>
        <el-form :model="addCouponForm" :rules="addCouponRules" ref="addCouponForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="addCouponForm.title"></el-input>
          </el-form-item>
          <el-form-item label="消费满" prop="minUsePrice">
            <el-input-number v-model="addCouponForm.minUsePrice" :precision="2" :step="1" :min="0"></el-input-number>
            <span style="padding: 0 8px; box-sizing: border-box">减</span>
            <el-input-number v-model="addCouponForm.price" :precision="2" :step="1" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="券数量" prop="totalCount">
            <el-input v-model="addCouponForm.totalCount" placeholder="请输入优惠券数量"></el-input>
          </el-form-item>
          <el-form-item label="有效时间" prop="expireDay">
            <el-date-picker v-model="addCouponForm.expireDay" type="datetime" placeholder="请选择有效时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="使用须知" prop="introduce">
            <el-input type="textarea" placeholder="请输入需要备注的内容~" v-model="addCouponForm.introduce"></el-input>
          </el-form-item>
          <el-form-item label="开启折上优惠" prop="openDoubleDiscounts">
            <el-switch v-model="addCouponForm.openDoubleDiscounts"></el-switch>
            <span class="pl10">在使用会员折扣的同时可使用优惠券</span>
          </el-form-item>
          <el-form-item label="分享得金额" prop="openShareAmount">
            <el-switch v-model="addCouponForm.openShareAmount"></el-switch>
            <span class="pl10">分享给好友，好友领取后，到店消费核销分享者会员余额会增加设置的金额。达到促进顾客分享的意愿。</span>
          </el-form-item>
          <el-form-item label="裂变消费到账" prop="shareGetAmount">
            <el-input v-model="addCouponForm.shareGetAmount" placeholder="请输入裂变消费到账金额"></el-input>
          </el-form-item>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAllianceCouponDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAllianceCoupon">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看使用详情 -->
    <el-dialog :title="title + '优惠券使用详情'" :visible.sync="dialogVisible" width="32%">
      <el-table :data="sigleTableData" style="width: 100%">
        <el-table-column prop="userPhoneNum" label="用户"></el-table-column>
        <el-table-column prop="usedTime" label="使用时间"></el-table-column>
        <el-table-column prop="operateUserName" label="操作员名字" align="right"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="visibleAppltQrcodeImg" :close-on-click-modal="false" :close-on-press-escape="false" width="380px">
      <div style="text-align: center">
        <qrcode :value="appltQrcodeImg" :options="{ size: 300 }" class="applt-qrcode"></qrcode>
        <!-- <img class="applt-qrcode" :src="appltQrcodeImg" alt="" /> -->
        <el-button type="primary" @click="downPayCode">下载小程序码</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCashCouponList,
  addPublishCashCoupon,
  offCashCouponUsedDetail,
  singleCashCouponUsedDetail,
  deleteCashCoupon,
  addQrCodeJumpParkingCoupon,
} from "@/api/index";
import { mapState } from "vuex";
import { commonFuc } from "@/mixins/commonFuc";
import qrcode from "@xkeshi/vue-qrcode";

export default {
  mixins: [commonFuc],
  data() {
    return {
      appltQrcodeImg: "",
      visibleAppltQrcodeImg: false,
      sendCouponQrCodeValue: "",
      orderType: {},
      keywords: "",
      cardStatus: "",
      cardStatusOptions: [
        { value: "", label: "全部" },
        { value: "1", label: "正常" },
        { value: "0", label: "已停用" },
      ],
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isTableLoading: false,
      usedCount: 0,
      deductionAmount: 0,
      addCouponDialogVisible: false,
      addCouponForm: {
        chooseCouponId: "",
        title: "",
        expireDay: "",
        checkList: [],
        discount: "",
        openDoubleDiscounts: false,
        enablePopup: false,
        minUsePrice: "",
        price: "",
        totalCount: "",
        introduce: "",
        receiveMaxCount: "",
        openShareFission: false,
        openReceiveAfterPay: false,
        openReceiveInYSC: false,
        shareGetAmount: "",
        openShareAmount: false,
        applyMark: "",
        isShow: true,
      },
      addCouponRules: {
        chooseCouponId: [{ required: true, message: "请选择券类型", trigger: "blur" }],
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        openDoubleDiscounts: [
          { required: true, message: "是否开启折上折", trigger: "change" },
        ],
        enablePopup: [{ required: true, message: "是否弹窗提示", trigger: "change" }],
        expireDay: [{ required: true, message: "请选择有效日期", trigger: "change" }],
        price: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.addCouponForm.minUsePrice == 0 && this.isHavPriceLimit) {
                callback(new Error("最低使用金额不能为0"));
              } else if (this.addCouponForm.price == 0) {
                callback(new Error("金额不能为0"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        totalCount: [{ required: true, message: "请输入优惠券数量", trigger: "blur" }],
        introduce: [{ required: true, message: "请输入使用须知", trigger: "blur" }],
        receiveMaxCount: [
          {
            required: true,
            message: "请输入最多可领取的优惠券数量",
            trigger: "blur",
          },
        ],
        openShareFission: [
          { required: true, message: "是否支持裂变", trigger: "change" },
        ],
        openReceiveAfterPay: [{ required: true, message: "请选择", trigger: "change" }],
        shareGetAmount: [
          {
            required: true,
            message: "请输入裂变消费到账金额",
            trigger: "blur",
          },
        ],
        openShareAmount: [{ required: true, message: "请选择", trigger: "change" }],
        couponValue: [{ required: true, message: "请选择", trigger: "change" }],
        applyMark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      addAllianceCouponDialogVisible: false,
      dialogVisible: false,
      sigleTableData: [],
      couponScreenList: [],
      couponValues: "",
      title: "",
      orderStatusOptions: {
        1: "未使用",
        2: "已发布",
        3: "已用完",
        4: "商家停止发放",
        100: "审核中",
        101: "审核失败",
      },
    };
  },
  components: {
    qrcode,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
      oemInfo: (state) => state.oemInfo,
    }),
    isShowRemark() {
      let arr = [11, 13, 16, 21, 22, 23, 24, 25, 26];
      return (
        arr.includes(this.addCouponForm.chooseCouponId) &&
        this.addCouponForm.chooseCouponId != 3
      );
    },
    isHavPriceLimit() {
      return (
        this.addCouponForm.chooseCouponId != 3 && this.addCouponForm.chooseCouponId != 29
      );
    },
    isShowAppltSetting() {
      return this.addCouponForm.chooseCouponId == 3;
    },
    isShowDoubleDiscountsSetting() {
      return (
        this.addCouponForm.chooseCouponId == 0 || this.addCouponForm.chooseCouponId == 31
      );
    },
    couponList() {
      let baseList = [
        {
          id: 1,
          typeName: "综合券",
          typeExplain: "",
          comprehensiveStampsList: [
            {
              id: 0,
              imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
              title: "普通抵用券",
              subTitle: "普通抵用券、普通抵用券",
              isOpen: false,
            },
            {
              id: 2,
              imgUrl: require("@/assets/img/couponList/affiliateCoupon.png"),
              title: " 联盟优惠券",
              subTitle: "联盟优惠券、联盟优惠券",
              isOpen: false,
            },
          ],
        },
        {
          id: 2,
          typeName: "支付宝代金券",
          typeExplain:
            "注意：顾客使用支付宝付款时可直接核销。会与商户券叠加，请了解后使用。以财务账单对账为准，本页面不做统计",
          comprehensiveStampsList: [
            {
              id: 10,
              imgUrl: require("@/assets/img/couponList/alipayCoupon.png"),
              title: "支付宝API制券",
              subTitle: "使用支付宝API进行制券",
              isOpen: false,
            },
            {
              id: 11,
              imgUrl: require("@/assets/img/couponList/alipayScanCoupon.png"),
              title: " 支付宝扫码领券",
              subTitle:
                "《顾客拉新》返回的微信支付代金券二维码可用于线下地推，或者朋友圈推广，群内发布。促进二次消费",
              isOpen: true,
            },
            {
              id: 12,
              imgUrl: require("@/assets/img/couponList/alipayGift.png"),
              title: "支付宝支付有礼",
              subTitle:
                "《促进二次消费》顾客在支付宝支付后将显示代金券，顾客可直接领取，促进二次消费",
              isOpen: true,
            },
            // {
            //   id: 13,
            //   imgUrl: require("@/assets/img/couponList/alipayFreeSpread.png"),
            //   title: "支付宝其他途径免费推广 ",
            //   subTitle:
            //     "《顾客拉新》选择此渠道后，将在支付宝内自动匹配其他合适途径为您推广",
            //   isOpen: true,
            // },
          ],
        },
        // {
        //   id: 3,
        //   typeName: "微信支付代金券",
        //   typeExplain:
        //     "注意：顾客使用微信付款时可直接核销。会与商户券叠加，请了解后使用。以财务账单对账为准，本页面不做统计。",
        //   comprehensiveStampsList: [
        //     {
        //       id: 20,
        //       imgUrl: require("@/assets/img/couponList/weChatCoupon.png"),
        //       title: "微信支付API制券",
        //       subTitle: "使用微信支付API进行制券",
        //       isOpen: false,
        //     },
        //     {
        //       id: 21,
        //       imgUrl: require("@/assets/img/couponList/weChatScanCoupon.png"),
        //       title: " 微信支付扫码领券",
        //       subTitle:
        //         "《顾客拉新》返回的二维码可用于微信支付代金券线下地推，或者朋友圈推广，群内发布。促进二次消费",
        //       isOpen: true,
        //     },
        //     {
        //       id: 22,
        //       imgUrl: require("@/assets/img/couponList/weChatGift.png"),
        //       title: " 微信支付支付有礼",
        //       subTitle:
        //         "《促进二次消费》顾客在微信支付支付后将显示代金券，顾客可直接领取，促进二次消费",
        //       isOpen: true,
        //     },
        //     // {
        //     //   id: 23,
        //     //   imgUrl: require("@/assets/img/couponList/weChatNearByCoupon.png"),
        //     //   title: "微信支付附近发券 ",
        //     //   subTitle:
        //     //     "《促进二次消费》顾客在微信支付支付后将显示代金券，顾客可直接领取，促进二次消费",
        //     //   isOpen: true,
        //     // },
        //     {
        //       id: 24,
        //       imgUrl: require("@/assets/img/couponList/weChatPaysTheCoupon.png"),
        //       title: " 微信支付配额发券",
        //       subTitle:
        //         "《顾客拉新》与附近发券功能一致，需要有配额才可，配额需要核销代金券获得",
        //       isOpen: true,
        //     },
        //     // { id: 25, imgUrl: require('@/assets/img/couponList/weChatCircleOfFriends.png'), title: "  微信支付朋友圈发券", subTitle: "《顾客拉新》朋友圈发券是微信支付官方推出的营销工具，根据商户经营需求，智能为其定制代金券营销方案，代金券可在微信社交渠道中投放，包括但不限于朋友圈、公众号。用户领取代金券后，到店使用微信支付时自动核销，推广效果闭环，为商户带来营业额和品牌提升。注意：上个月线下交易笔数要求，商户行业以零售和餐饮行业为主", isOpen: true }
        //   ],
        // },
      ];
      if (this.isOwn || (!this.isOwn && this.oemInfo && this.oemInfo.isOpenBdmOem)) {
        baseList[0].comprehensiveStampsList.push(
          ...[
            {
              id: 29,
              imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
              title: "无门槛云推赠送券",
              subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
              isOpen: true,
            },
            {
              id: 30,
              imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
              title: "普通云推满减券",
              subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
              isOpen: true,
            },
            {
              id: 31,
              imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
              title: "云推支付券",
              subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
              isOpen: true,
            },
          ]
        );
        baseList[1].comprehensiveStampsList.push({
          id: 16,
          imgUrl: require("@/assets/img/couponList/alipayFreeSpread.png"),
          title: "支付宝云推码券 ",
          subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
          isOpen: true,
        });
        // baseList[2].comprehensiveStampsList.push({
        //   id: 26,
        //   imgUrl: require("@/assets/img/couponList/weChatPaysTheCoupon.png"),
        //   title: " 微信支付云推码券",
        //   subTitle: "《顾客拉新，门店引流》顾客可通过云推码视频推广活动可以领取此券",
        //   isOpen: true,
        // });
      }
      if (this.isOwn && this.shopInfo.edcShopType == 14) {
        baseList[0].comprehensiveStampsList.push({
          id: 3,
          imgUrl: require("@/assets/img/couponList/generalVouchers.png"),
          title: "停车券",
          subTitle: "停车券",
          isOpen: true,
        });
      }
      this.couponScreenList = [];
      baseList.forEach((val) => {
        val.comprehensiveStampsList.forEach((sval) => {
          this.couponScreenList.push({
            value: sval.id,
            label: sval.title,
          });
          this.orderType[sval.id] = {
            title: sval.title,
          };
        });
      });
      this.$forceUpdate();
      return baseList;
    },
  },
  watch: {
    couponValues() {
      this.getCashCouponList();
    },
    cardStatus() {
      this.getCashCouponList();
    },
    addCouponDialogVisible(val) {
      if (!val) {
        this.addCouponForm.chooseCouponId = "";
        this.addCouponForm = {
          title: "",
          expireDay: "",
          checkList: [],
          discount: "",
          openDoubleDiscounts: false,
          enablePopup: false,
          minUsePrice: "",
          price: "",
          totalCount: "",
          introduce: "",
          receiveMaxCount: "",
          openShareFission: false,
          openReceiveAfterPay: false,
          openReceiveInYSC: false,
          shareGetAmount: "",
          openShareAmount: false,
          applyMark: "",
          isShow: true,
        };
      }
    },
  },
  mounted() {
    this.getCashCouponList();
  },
  methods: {
    downPayCode() {
      let canvas = document.querySelector(".applt-qrcode");
      let dataURL = canvas.toDataURL("image/png");
      let a = document.createElement("a"); // 创建一个a节点插入的document
      let event = new MouseEvent("click"); // 模拟鼠标click点击事件
      a.download = "paycode.png"; // 设置a节点的download属性值
      a.href = dataURL; // 将图片的src赋值给a节点的href
      a.dispatchEvent(event);
    },
    getCashCouponList() {
      this.isTableLoading = true;
      getCashCouponList({
        pageNumber: this.pageNo,
        row: this.pageSize,
        isEnable: this.cardStatus,
        title: this.keywords,
        batchOrderType: this.couponValues,
      }).then((res) => {
        this.isTableLoading = false;
        if (res.code == 1) {
          this.tableData = res.data.pager.list;
          this.total = res.data.pager.totalCount;
          this.usedCount = res.data.statistics.usedCount;
          this.deductionAmount = res.data.statistics.deductionAmount.toFixed(2);
        } else if (res.code == -1) {
          this.tableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCashCouponList();
    },
    search() {
      this.pageNo = 1;
      this.getCashCouponList();
    },
    // 添加优惠券
    addPublishCashCoupon() {
      this.$refs.addCouponForm.validate((valid) => {
        if (valid) {
          addPublishCashCoupon({
            title: this.addCouponForm.title,
            minUsePrice:
              this.addCouponForm.chooseCouponId == 3 ? 1 : this.addCouponForm.minUsePrice,
            price: this.addCouponForm.price,
            totalCount: this.addCouponForm.totalCount,
            expireDay: this.addCouponForm.expireDay,
            introduce: this.addCouponForm.introduce,
            receiveMaxCount: this.addCouponForm.receiveMaxCount || 1,
            openDoubleDiscounts: this.addCouponForm.openDoubleDiscounts ? 1 : 0,
            enablePopup:
              this.addCouponForm.chooseCouponId !== 0
                ? 1
                : this.addCouponForm.enablePopup
                  ? 1
                  : 0,
            batchOrderType: this.addCouponForm.chooseCouponId,
            applyMark: this.addCouponForm.applyMark,
            wxMiniAppisShow: this.addCouponForm.isShow ? 1 : 0,
          }).then((res) => {
            this.addCouponDialogVisible = false;
            this.addCouponForm.chooseCouponId = "";
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getCashCouponList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    // 添加联盟优惠券
    addAllianceCoupon() {
      this.addCouponForm.openDoubleDiscounts == true
        ? (this.addCouponForm.openDoubleDiscounts = 1)
        : (this.addCouponForm.openDoubleDiscounts = 0);
      this.addCouponForm.openShareAmount == true
        ? (this.addCouponForm.openShareAmount = 1)
        : (this.addCouponForm.openShareAmount = 0);
      addPublishCashCoupon({
        title: this.addCouponForm.title,
        minUsePrice: this.addCouponForm.minUsePrice,
        price: this.addCouponForm.price,
        totalCount: this.addCouponForm.totalCount,
        expireDay: this.addCouponForm.expireDay,
        introduce: this.addCouponForm.introduce,
        receiveMaxCount: 1,
        openDoubleDiscounts: this.addCouponForm.openDoubleDiscounts,
        openShareAmount: this.addCouponForm.openShareAmount,
        wxMiniAppisShow: this.addCouponForm.isShow ? 1 : 0,
      }).then((res) => {
        this.addAllianceCouponDialogVisible = false;
        if (res.code == 1) {
          this.$message.success(res.msg);
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    offCashCouponUsedDetail(row) {
      this.$confirm("此操作将停用该优惠券, 是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(({ value }) => {
          offCashCouponUsedDetail({
            cashCouponBatchOrderId: row.id,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
              this.getCashCouponList();
            } else if (res.code == 2) {
              this.$message.error(res.msg);
              this.$router.push("/");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    lookMore() {
      this.$router.push("/cardCoupon/cardCouponList");
    },
    lookSingleDetail(row) {
      this.dialogVisible = true;
      console.log(row); // row.title   row.id
      this.title = row.title;
      singleCashCouponUsedDetail({
        pageNumber: 1,
        cashCouponBatchOrderId: row.id,
      }).then((res) => {
        if (res.code == 1) {
          this.sigleTableData = res.data;
        } else if (res.code == -1) {
          this.sigleTableData = [];
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    deleteCashCoupon(row) {
      this.$confirm("您确定要删除该优惠券吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCashCoupon({
            cashCouponBatchOrderId: row.id,
          }).then((res) => {
            if (res.code == 1) {
              this.getCashCouponList();
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
        .catch(() => { });
    },
    resetSubmit(row) {
      console.log(row, "重新提交");
      Object.assign(this.addCouponForm, row);
      this.addCouponForm.chooseCouponId = row.orderType;
      this.addCouponForm.isShow = row.isShow ? true : false;
      this.addCouponDialogVisible = true;
    },
    goAllianceCoupon() {
      this.$router.push("/cardCoupon/allianceCoupon");
    },
    // 下载二维码
    downLoadCode(row) {
      this.sendCouponQrCodeValue = row.sendCouponQrCodeValue;
      setTimeout(() => {
        let canvas = document.querySelector(".code-canvas");
        let dataURL = canvas.toDataURL("image/png");
        let a = document.createElement("a"); // 创建一个a节点插入的document
        let event = new MouseEvent("click"); // 模拟鼠标click点击事件
        a.download = "二维码.png"; // 设置a节点的download属性值
        a.href = dataURL; // 将图片的src赋值给a节点的href
        a.dispatchEvent(event);
      }, 0);
    },
    createAppltQrcode(item) {
      addQrCodeJumpParkingCoupon({
        cashCouponBatchOrderId: `${String(item.id)}`,
      }).then((res) => {
        if (res.code == 1) {
          this.appltQrcodeImg = res.data.url;
          this.visibleAppltQrcodeImg = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.card-coupon-page {
  .tab-header {
    .header-right {
      align-items: center;

      .el-input,
      .el-select {
        width: 200px;
      }
    }
  }

  .tab-content {
    flex-direction: column;

    .list {
      width: 100%;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
}

.none {
  display: none;
}

.block {
  display: block;
}

#canvas {
  width: 55% !important;
  height: auto !important;
}

.pr30 {
  padding-right: 30px;
  box-sizing: border-box;
}

.colorblue {
  color: #3388ff;
  cursor: pointer;
  margin-right: 10px;
}

.pl10 {
  padding-left: 10px;
  box-sizing: border-box;
  color: #ff7757;
}

.tips {
  width: 100%;
  height: auto;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ff9191;
  background: #ffe6e6;
  color: #ff7757;
  font-size: 12px;
}

.cardCoupon-state {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  margin-bottom: 10px;
}

.card-coupon-page {
  // padding: 30px 20px 20px 30px;
  box-sizing: border-box;
  height: calc(100% - 80px);
  overflow-y: scroll;

  .card-coupon {
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .flex-row-start {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;

    .activity-name {
      padding-right: 10px;
      box-sizing: border-box;
      line-height: 40px;
    }

    .bold {
      font-weight: bold;

      .color-orange {
        color: #ff7757;
        cursor: pointer;
      }
    }
  }

  .table-area {
    padding-top: 25px;
    box-sizing: border-box;
  }
}

/deep/ .el-table th {
  background-color: #f7f8fa;
}
</style>

<style lang="less">
.coupon-list {
  width: 358px;

  .el-scrollbar {
    height: 500px;

    .el-scrollbar__wrap {
      max-height: 500px;
    }
  }

  .el-select-dropdown__item {
    height: auto;
  }

  .comprehensiveStamps {
    width: 318px;
    min-height: 56px;
    height: auto;
    background: #fff;
    box-shadow: 2px 3px 9px 0px rgba(0, 0, 0, 0.02);
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
    margin: 10px 0;
    position: relative;

    .title {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #303133;
      position: relative;
      line-height: 1.5;
    }

    .typeExplain {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #f56c6c;
      line-height: 40px;
    }

    .title1 {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      width: 100%;
      // width: 200px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      // margin-top: 10px;
      white-space: normal;
      line-height: 1.5;
    }

    .subTitle {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      width: 200px;
    }

    &:hover {
      .title1 {
        overflow: visible;
        text-overflow: none;
        display: block;
        -webkit-line-clamp: 99;
        -webkit-box-orient: vertical;
      }

      .triangle-up {
        transform: rotate(135deg);
      }
    }

    &:first-child {
      margin-left: 0;
    }

    .img {
      width: 20px;
      height: 20px;

      // margin-right: 10px;
      img {
        width: 20px;
        height: 20px;
      }
    }

    .couponExplain {
      // min-height: 60px;
      padding-left: 10px;
      box-sizing: border-box;
    }

    .triangle-up {
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      border-top: 1px solid #999;
      border-right: 1px solid #999;
      position: absolute;
      right: 11px;
      bottom: 35px;
      transition: all 0.5s;
    }

    .triangle-down {
      width: 8px;
      height: 8px;
      transform: rotate(136deg);
      border-top: 1px solid #999;
      border-right: 1px solid #999;
      position: absolute;
      right: 11px;
      bottom: 35px;
    }
  }
}
</style>
